const Error = () => {
  return (
    <h1 className='text-center text-3xl m-16'>please refresh the page</h1>
  )
}

export { Error }